var $ = require('jquery');
require('./mask.js');
var reveals = require('./0reveals');
var shuffle = require('shuffle');
var pictoAnim = require('./pictoanim.js');
require('wrapmask');
var first_pass = true;
var cymasmooth = require('cymasmooth');
var MQ = require('mq');

reveals('homemodelanim', function(el, tl, start_label){
	// alert('home')
	// tl.to( el, 1.5, {
	// 	opacity: 1
	// }, start_label );

	// try {
	// 	// body...
	// 	alert(cymasmooth.prev_page.model);
	// 	alert(cymasmooth.next_page.model);
	// } catch(e){}

	if ( first_pass && $('.intro__wrap').length == 0 ) {
		// tl.to( $('.site__loader__bg'), 0.9, {
		// 	opacity: 0,
		// 	// scale:1.3,
		// 	ease: 'linear'
		// }, start_label )
		// tl.to( $('.site__loader'), 1.5, {
		// 	scale: 1.3,
		// 	opacity: 0,
		// 	// scale:1.3,
		// 	ease: 'power1.in'
		// }, start_label+'+=0' )
		// tl.set( $('.header'), {
			// opacity: 1
		// }, start_label+'+=0' )
		// tl.add( function(){
			// $('.header').data('tl').play();
		// }, start_label )
		// var header = $('.header');
		// // if (MQ(-768)) {
		// // 	header = $('.header__logo__n__toggle__inner')
		// // }
		// tl.fromTo(header, {
		// 	y: '-50rem',
		// 	opacity: 0,
		// }, {
		// 	y: '0rem',
		// 	opacity: 1,
		// 	duration: 1.2
		// }, start_label + '+=0.9');
		// tl.fromTo($('.theme__aside__inner'), {
		// 	y: '-100%',
		// 	opacity: 0,
		// }, {
		// 	y: '0%',
		// 	opacity: 1,
		// 	duration: 1.2
		// }, start_label + '+=1.1');
		
		// tl.fadeUp( $('.header__logo'), {
		// 	xOrigin: -30,
		// 	yOrigin: 6
		// }, start_label+'+=0.5' )
		// tl.fadeUp( $('.menu__item__li, .header__sep, .header__language__list li'), {
		// 	xOrigin: 30,
		// 	stagger: 0.075,
		// 	yOrigin: 0
		// }, start_label+'+=0.6' )
		// tl.fadeUp( $('.header__toggler__wrap '), {
		// 	xOrigin: 30,
		// 	stagger: 0.075,
		// 	yOrigin: 0
		// }, start_label+'+=0.6' )
		// tl.fadeUp( $('.header__logo__n__toggle__wrap'), {
		// 	yOrigin: '-30%'
		// }, start_label+'+=0.6' )
		// var el = $('.header__inner, .header__bg');
		// if ( MQ(-767) ){
		// 	el = $('.header__logo__n__toggle__wrap');
		// }
		// el.addClass('wc');
		// tl.from( el, {
		// 	duration: 1,
		// 	y: '-30%',
		// 	opacity: 0,
		// 	clearProps: 'transform'
		// }, start_label+'+=0.6' )
		// tl.add(function(){
		// 	el.removeClass('wc');
		// }, start_label+'+=1.6' )
		
		// tl.fadeUp( $('.header__logo__n__toggle > div'), {
		// 	yOrigin: -30
		// }, start_label+'+=0.5' )
		// if ( MQ(768) ) {
		// 	tl.fromTo( $('.header'), {
		// 		opacity: 0
		// 	}, start_label );
		// }
		// var header = $('.header__blocb');
		// if ( MQ(-767) ){
		// 	header = $('.header__logo__n__toggle__wrap');
		// }
		// tl.fromTo( header, 1.5, {
		// 	y: '-50rem',
		// 	opacity: 0
		// }, {
		// 	y: '0%',
		// 	opacity: 1,
		// 	clearProps: 'all'
		// }, start_label );
		// tl.fadeUp( $('.home__intro__tlfadeup'), {}, start_label );
		tl.add(function(){
			// $('.site__loader__wrap').remove();
			console.log('loadingAnimationDoneloadingAnimationDoneloadingAnimationDoneloadingAnimationDone');
			$(window).trigger('loadingAnimationDone');
		});
		// tl.fromTo( $('.header__menu__ul__a > li'), 0.5, {
		// 	y: '-50rem',
		// 	opacity: 0
		// }, {
		// 	y: '0rem',
		// 	opacity: 1
		// }, start_label+'+=0.25' );
		// var linea = $('.header__menu__ul__a > li').get().reverse();
		// // linea.push.apply(linea, lineb);
		// tl.fromTo( linea, {
		// 	opacity: 0,
		// 	x: '25rem',
		// }, {
		// 	opacity: 1,
		// 	x: '0rem',
		// 	stagger: 0.1,
		// 	duration: 0.75,
		// 	ease: Power2.easeOut
		// }, start_label+'+=0.35' )
		// tl.from( $('.header__bloca__inner').find('.header__questions, .header__resos, .header__langs'), {
		// 	opacity: 0,
		// 	y: '-101%',
		// 	stagger: 0.1,
		// 	duration: 0.75,
		// 	ease: Power2.easeOut
		// }, start_label+'+=0.75' )
		// tl.from( $('.pagehead__drlocator__innerr, .pagehead__scrolltop'), {
		// 	opacity: 0,
		// 	y: '101%',
		// 	stagger: 0.25,
		// 	duration: 1,
		// 	ease: Power2.easeOut
		// }, start_label+'+=0.95' )
		// tl.from( $('.header__logo__bg'), 0.9, {
		// 	x: '-100%',
		// 	y: '-100%',
		// 	ease: 'power2.out'
		// }, start_label+'+=0.5' );
		// tl.from( $('.header__logo__link__wrap, .header__slogan__inner, .header__toggler__wrap'), 0.9, {
		// 	opacity: 0,
		// 	y: '-60rem',
		// 	ease: 'power2.out',
		// 	stagger: 0.1
		// }, start_label+'+=0.75' );
		
	}
	else {
		
	}

	// if ($(el).find('.headerpage__visuel').length) {
	// 	tl.from($(el).find('.headerpage__visuel'), {
	// 		scale: 1.05,
	// 		duration: 1.9,
	// 	}, start_label);
	// 	// tl.to($(el).find('.headerpage__visuel__overlay'), {
	// 	// 	x: '0%',
	// 	// 	duration: 1.9,
	// 	// }, start_label);
	// 	tl.fadeUp($(el).find('.headerpage__page__titre__wrap, .headerpage__texte'), {

	// 	}, start_label + '+=0.6');
	// 	tl.from($(el).find('.headerpage__scrolldown'), {
	// 		opacity: 0,
	// 		duration: 0.6,
	// 		ease: 'none'
	// 	}, start_label + '+=0.8');
	// 	tl.from($(el).find('.headerpage__scrolldown path'), {
	// 		y: '-25rem',
	// 		duration: 0.9,
	// 		// ease: 'none'
	// 	}, start_label + '+=0.8');
	// }

	var footerDecal = '0.5';

	

	if ( cymasmooth.next_page.model == 'home' ){
		// tl.from( $('.home__visuel'), {
		// 	scale: 1.1,
		// 	duration: 2.2,
		// 	ease: 'power2.out',
		// }, start_label );
		// tl.fadeUp( $('.home__logo .svg__wrap, .home__play__wrap, .home__titre, .home__texte, .home__cta'), {
		// 	duration: 1.3
		// }, start_label+'+=0.6' )
		
	}

	if ( cymasmooth.next_page.model == 'projetspost-detail' ){
		if ( $('.projetliste__hover__transition').length ) {
			tl.addLabel('pageanim', start_label + '+=1');
			$('.projetliste__hover__transition').css({transition:'none'});
			tl.fromTo( $('.projetliste__hover__transition'), {
				y: '0%',
			}, {
				y: '-100%',
				ease: 'power2.in',
				duration: 0.5,
				stagger: 0,
			}, start_label + '+=0.5' )
			tl.fromTo( $('.projetliste__hover__transition__inner'), {
				y: '0%',
			}, {
				y: '100%',
				ease: 'power2.in',
				duration: 0.5,
				stagger: 0,
			}, start_label + '+=0.5' )
		}
		else {
			tl.addLabel('pageanim', start_label + '+=0.5');
		}
		footerDecal = '1.6';
		tl.add(function(){
			$('.projetliste__hover__transition').remove();
		}, 'pageanim');
		tl.from( $('.projetspost__visuels__group__groupes__items'), {
			opacity: 0,
			ease: 'none',
		}, 'pageanim')
		if ( MQ(768) ) {
			tl.fadeUp( $('.projetspost__titre, .slideshow__nbs__wrap, .projetspost__visuels__group__groupes__items__navs'), {
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.2')
			tl.from( $('.projetspost__infos__back'), {
				x: '50rem',
				opacity: 0,
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.6')
			tl.from( $('.projetspost__infos__credits'), {
				x: '-50rem',
				opacity: 0,
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.6')
		}
		else {
			tl.fadeUp( $('[data-reveal-xs-order]').sortCustom('data-reveal-xs-order'), {
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.2')
			tl.from( $('.projetspost__visuels__group__groupes__items__arrow.prev'), {
				x: '30rem',
				opacity: 0,
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.6')
			tl.from( $('.projetspost__visuels__group__groupes__items__arrow.next'), {
				x: '-30rem',
				opacity: 0,
				duration: 1.2,
				ease: "power2.out"
			}, 'pageanim+=0.6')
		}
		
	}

	if ( cymasmooth.next_page.model == 'artist' ){
		tl.addLabel('pageanim', start_label + '+=0.5');
		var lines = new SplitText($('.artist__intro__group__texte .inner'), {type:'lines'}).lines;
		tl.fadeUp( $('.artist__intro__item__picto'), {
			xOrigin: '-50rem',
			yOrigin: 0,
			ease: 'power2.out',
		}, 'pageanim')
		tl.fadeUp( lines, {
			xOrigin: '-50rem',
			yOrigin: 0,
			ease: 'power2.out',
		}, 'pageanim+=0.4')
		
	}

	tl.from( $(el).find('.footer').addClass('wc'), {
		// y: '50rem',
		opacity: 0,
		stagger: 0.1,
		duration: 1.1,
	}, start_label + '+=' + footerDecal )

	first_pass = false;

	


	return;

	tl.from( $('.header__line'), {
		scaleX: 0,
		duration: 1,
		opacity: 0,
		transformOrigin: '50% 50%',
		ease: Power2.easeOut
	}, '>-0.5' )

	var ways = [
		{x:'-115%',y:'0%'},
		{x:'0%',y:'115%'},
		{x:'-115%',y:'0%'},
		{x:'0%',y:'-115%'}
	];

	var ways = [
		{x:'-115%',y:'0%'},
		{x:'0%',y:'115%'},
		{x:'0%',y:'-115%'}
	];

	// var ways = [
	// 	{x:'0%',y:'115%'}
	// ];

	$('.home__intro__yas g').wrapmasksvg({
		offset: 1
	}).els.each(function(i, g){
		tl.from( g, 0.8, {
			x: ways[i % ways.length ].x,
			y: ways[i % ways.length ].y,
		}, start_label + '+=' + ( 0.5 + i * 0.05 ) );


	})

	tl.addLabel( 'introtxts', '-=0.1' );

	// tl.from( $('.home__intro__txta'), 1.1, {
	// 	opacity: 0,
	// 	ease: Power0.easeOut
	// }, 'introtxts' );

	// tl.from( $('.home__intro__txtb'), 1.1, {
	// 	opacity: 0,
	// 	ease: Power0.easeOut
	// }, 'introtxts+=0.1' );

	var lines_a = new SplitText($('.home__intro__txta'), {type:'lines'}).lines;
	var lines_b = new SplitText($('.home__intro__txtb'), {type:'lines'}).lines;

	tl.from( $(lines_a).add(lines_b), 1.1, {
		opacity: 0,
		stagger: 0.033,
		ease: Power0.easeOut
	}, 'introtxts' );

	tl.from( $('.home__intro__scroll__down'), 1.1, {
		opacity: 0,
		ease: Power0.easeOut
	}, 'introtxts+=0.2' );

	

	// tl.from( $('.header__menu__li, .header__language__list li, .header__logo, .header__logo__n__toggle, .header__toggler__wrap'), 1.1, {
	// 	opacity: 0,
	// 	// y: '-30rem',
	// 	stagger: 0.05,
	// 	ease: Power0.easeOut
	// }, start_label + '+=0.1' );
	// }, 'introtxts+=0.3' );

	tl.from( $('.home__intro__y__bg'), 2.5, {
		scale: 1.25,
		transformOrigin: '50% 50%',
		ease: Power1.easeOut
	}, start_label );

	// var els = [];
	// els.push( $(el).find('.home__bg__wrap').get(0) );
	// els.push( $(el).find('.home__visu__wrap').get(0) );
	// els.push( $(el).find('.home__baseline__wrap').get(0) );
	// els.push( $(el).find('.home__txt__picto').get(0) );
	// els.push( $(el).find('.home__txt').get(0) );
	// els.push( $(el).find('.foot__menu').get(0) );
	// els.push( $(el).find('.home__cta__enter__wrap').get(0) );

	// tl.staggerFromTo( els, 2, {
	// 	opacity: 0
	// }, {
	// 	opacity: 1,
	// 	ease: Power1.easeInOut
	// }, 0.25,  start_label + '+=0')

	// tl.addLabel( 'lines', start_label+'+=0.2' );



	

	// tl.fromTo( pictoAnim( $(el).find('.home__picto') ), 0.8, {
	// 	progress: 0
	// }, {
	// 	progress: 1,
	// 	ease: Power0.easeOut
	// }, 'lines' )

	// tl.staggerFromTo( $(el).find('.we__txt__bloc, .home__menu__link '), 0.9, {
	// 	scale: 0.5,
	// 	opacity: 0
	// }, {
	// 	scale: 1.01,
	// 	opacity: 1,
	// 	ease: Power2.easeOut
	// }, 0.05, 'lines' )



});
